(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  /* Add the private SDB Staff Portal link to Shopify's existing mobile drawer.
     This does not touch the customer account icon or Shopify menu settings. */
  function sdbAddStaffPortalToMobileDrawer() {
    document.querySelectorAll('header-drawer').forEach((drawer) => {
      const menu = drawer.querySelector('.menu-drawer__navigation .menu-drawer__menu');
      if (!menu || menu.querySelector('[data-sdb-staff-portal-drawer]')) return;
      if (menu.querySelector('a[href="/pages/staff-portal"]')) return;

      const item = document.createElement('li');
      item.className = 'sdb-drawer-staff-item';
      item.setAttribute('data-sdb-staff-portal-drawer', '');

      const link = document.createElement('a');
      link.href = '/pages/staff-portal';
      link.className = 'menu-drawer__menu-item list-menu__item link link--text focus-inset sdb-drawer-staff-link';
      link.setAttribute('aria-label', 'Staff Portal (secure staff access)');

      const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      icon.setAttribute('viewBox', '0 0 24 24');
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = '<rect x="5" y="10" width="14" height="11" rx="2"></rect><path d="M8 10V7a4 4 0 0 1 8 0v3"></path>';

      const label = document.createElement('span');
      label.textContent = 'Staff Portal';
      link.append(icon, label);
      item.appendChild(link);
      menu.appendChild(item);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sdbAddStaffPortalToMobileDrawer, { once: true });
  } else {
    sdbAddStaffPortalToMobileDrawer();
  }
  document.addEventListener('shopify:section:load', sdbAddStaffPortalToMobileDrawer);

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdbtrackmyorder"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
  if(!root||root.dataset.initialized==='true')return;
  root.dataset.initialized='true';
  var form=root.querySelector('.sdb-track__form');
  var message=root.querySelector('.sdb-track__message');
  var result=root.querySelector('.sdb-track__result');
  var submit=root.querySelector('.sdb-track__submit');
  var refresh=root.querySelector('[data-sdb-refresh]');
  var lastQuery=null,activeRequest=null;
  var labels={pending:'Awaiting dispatch',assigned:'Driver assigned',out_for_delivery:'Out for delivery',delivered:'Delivered',failed:'Delivery attempt unsuccessful',cancelled:'Delivery cancelled'};
  var stageMeta={
    pending:{label:'Awaiting dispatch',description:'We are preparing your order for dispatch.'},
    assigned:{label:'Driver assigned',description:'A driver has been allocated to your delivery.'},
    out_for_delivery:{label:'Out for delivery',description:'Your delivery is on its way.'},
    delivered:{label:'Delivered',description:'Your delivery has been completed. Thank you!'},
    failed:{label:'Delivery attempt unsuccessful',description:'Please contact our team about the next steps.'},
    cancelled:{label:'Delivery cancelled',description:'Please contact our team if you need assistance.'},
    unknown:{label:'Status unavailable',description:'Please try refreshing your delivery details.'}
  };
  var stages=[{key:'pending',title:'Delivery received'},{key:'assigned',title:'Driver assigned'},{key:'out_for_delivery',title:'On the way'},{key:'delivered',title:'Delivered'}];
  function showMessage(value,kind){message.textContent=value;message.dataset.kind=kind||'error';message.hidden=!value;}
  function humanDate(value,time){
    if(!value)return '';
    var dt;
    if(/^\d{4}-\d{2}-\d{2}$/.test(value))dt=new Date(value+'T12:00:00');
    else dt=new Date(String(value).replace(' ','T')+(String(value).indexOf('Z')===-1&&String(value).indexOf('+')===-1?'Z':''));
    if(Number.isNaN(dt.getTime()))return '';
    return new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/London',day:'numeric',month:'short',year:'numeric',...(time?{hour:'2-digit',minute:'2-digit'}:{})}).format(dt);
  }
  function paint(data){
    root.querySelector('[data-sdb-ref]').textContent=data.tracking;
    var status=root.querySelector('[data-sdb-status]');
    status.textContent=labels[data.status]||'Status available';
    status.dataset.kind=data.status||'unknown';
    var stage=stageMeta[data.status]||stageMeta.unknown;
    var stageCard=root.querySelector('[data-sdb-stage]');
    stageCard.dataset.state=stageMeta[data.status]?data.status:'unknown';
    root.querySelector('[data-sdb-stage-text]').textContent=stage.label;
    root.querySelector('[data-sdb-stage-sub]').textContent=stage.description;
    root.querySelector('[data-sdb-sparkles]').hidden=data.status!=='delivered';
    root.querySelector('[data-sdb-delivered]').textContent=humanDate(data.delivered_at,true)||'Not yet delivered';
    var timeline=root.querySelector('[data-sdb-timeline]');
    timeline.replaceChildren();
    var events=Array.isArray(data.events)?data.events:[];
    var reached=new Set(events.map(function(ev){return ev.status;}));
    // Use actual recorded progress. A failed/cancelled attempt does not imply delivery.
    if(data.status==='delivered')reached.add('delivered');
    if(data.status==='out_for_delivery')reached.add('out_for_delivery');
    if(data.status==='assigned')reached.add('assigned');
    reached.add('pending');
    // Active status is authoritative; old history must not suggest a rescheduled job is still en route.
    var livePosition={pending:0,assigned:1,out_for_delivery:2,delivered:3};
    var maxStage=Object.prototype.hasOwnProperty.call(livePosition,data.status)?livePosition[data.status]:0;
    if(data.status==='failed'||data.status==='cancelled'){
      stages.forEach(function(stage,i){if(reached.has(stage.key))maxStage=Math.max(maxStage,Math.min(i,2));});
    }
    stages.forEach(function(stage,i){
      var li=document.createElement('li');
      li.dataset.state=(data.status==='delivered'&&i===maxStage)||i<maxStage?'done':(i===maxStage?'current':'future');
      if((data.status==='failed'||data.status==='cancelled')&&i===maxStage)li.dataset.state='done';
      var mark=document.createElement('span');mark.className='sdb-track__mark';mark.textContent=i<maxStage||reached.has(stage.key)?'✓':'';mark.setAttribute('aria-hidden','true');
      var meta=document.createElement('div');
      var name=document.createElement('div');name.className='sdb-track__milestone';name.textContent=stage.title;meta.appendChild(name);
      var event=events.find(function(e){return e.status===stage.key;});
      if(event){var date=document.createElement('div');date.className='sdb-track__time';date.textContent=humanDate(event.at,true)||'';meta.appendChild(date);}
      li.append(mark,meta);timeline.appendChild(li);
    });
    var notice=root.querySelector('[data-sdb-notice]');
    var note=data.status==='failed'?'The last delivery attempt could not be completed. Our team will advise you about next steps.':data.status==='cancelled'?'This delivery is currently cancelled. Please contact our team if you need assistance.':'';
    notice.textContent=note;notice.hidden=!note;
    result.hidden=false;
  }
  async function lookup(values,quiet){
    if(activeRequest)activeRequest.abort();
    var control=new AbortController();activeRequest=control;
    submit.disabled=true;
    submit.querySelector('.sdb-track__submit-label').textContent='Checking delivery…';
    if(!quiet){result.hidden=true;showMessage('','');}
    try{
      var response=await fetch(root.dataset.endpoint,{method:'POST',mode:'cors',cache:'no-store',headers:{'Content-Type':'application/json'},body:JSON.stringify(values),signal:control.signal});
      var body=await response.json().catch(function(){return {};});
      if(!response.ok)throw new Error(response.status===404?'We could not find a delivery matching those details. Please check your tracking number and postcode.':(body.error||'Tracking is temporarily unavailable. Please try again.'));
      paint(body);showMessage('','');lastQuery=values;
    }catch(err){
      if(err.name==='AbortError')return;
      if(!quiet)result.hidden=true;
      showMessage(err instanceof TypeError?'Tracking is temporarily unavailable. Please try again shortly.':err.message,'error');
    }finally{
      if(activeRequest===control){activeRequest=null;submit.disabled=false;submit.querySelector('.sdb-track__submit-label').textContent='Track my delivery';}
    }
  }
  form.addEventListener('submit',function(event){
    event.preventDefault();
    var values={tracking:String(form.elements.tracking.value||'').trim().toUpperCase(),postcode:String(form.elements.postcode.value||'').trim().toUpperCase()};
    if(!values.tracking||!values.postcode){showMessage('Please enter your tracking reference and delivery postcode.');return;}
    lookup(values,false);
  });
  refresh.addEventListener('click',function(){if(lastQuery)lookup(lastQuery,true);});
  // Refresh a visible tracking result, never an invisible page or before first lookup.
  setInterval(function(){if(lastQuery&&!result.hidden&&!document.hidden&&!activeRequest)lookup(lastQuery,true);},60000);
  }
  function initAll(){
    document.querySelectorAll('.sdb-track[data-endpoint]').forEach(init);
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initAll,{once:true});
  }else{
    initAll();
  }
  document.addEventListener('shopify:section:load',initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
